import { FC } from 'react';
import Icon from '../icon';
import { createUseStyles } from 'react-jss';
import { Box } from '@mui/material';

interface Props {
  href: string;
  label?: string;
  withIcon?: boolean;
  inline?: boolean;
}

const useStyles = createUseStyles<string, { inline: boolean }>({
  externalLink: {
    display: ({ inline }) => (inline ? 'inline-flex' : 'flex'),
    flexDirection: 'row',
    gap: 2,
    alignItems: 'center',
    '& .label': {
      marginTop: -2,
    },
  },
});

const ExternalLink: FC<Props> = ({ href, label, inline = false, withIcon = true }) => {
  const styles = useStyles({ inline });
  const IconEl = withIcon ? <Icon name="link" size="small" /> : null;
  return (
    <a href={href} target="_blank" className={styles.externalLink} rel="noreferrer">
      {IconEl}
      <Box className="label">{label || href}</Box>
    </a>
  );
};

export default ExternalLink;
